import React from "react"
import { Canvas } from "@react-three/fiber"
import { Environment } from "@react-three/drei"
// import { Perf } from "r3f-perf"
import Scene from "./Scene"
import ShapeGroup from "./ShapeGroup"
import Shapes from "./Shapes"
import RotatingLight from "../atoms/RotatingLight"

const CanvasInner = () => {
  return (
    <Canvas
      shadows
      camera={{
        position: [0, 0, 8],
        fov: 20,
      }}
    >
      {/*<Perf />*/}

      <ambientLight intensity={0.5} />
      <spotLight position={[50, 50, -30]} castShadow />
      <pointLight position={[-10, -10, -10]} color="red" intensity={3} />
      <pointLight position={[0, -5, 5]} intensity={0.5} />
      <directionalLight position={[0, -5, 0]} color="red" intensity={2} />

      <RotatingLight />
      <Environment files="warehouse.hdr" />
      <Scene />
      <ShapeGroup>
        <Shapes />
      </ShapeGroup>
    </Canvas>
  )
}

export default CanvasInner
